import { makeClassName } from '@siteless/util';

const ArrowDownIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: unknown;
}) => (
  <svg
    className={makeClassName('ArrowDownIcon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...rest}
  >
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="12"
      y1="5"
      x2="12"
      y2="19"
    />
    <polyline
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="19 12 12 19 5 12"
    />
  </svg>
);

export default ArrowDownIcon;
